import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComments,
  faQuestionCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "../../../i18n/LanguageContext";

/**
 * Reusable "Looking for something else?" footer panel.
 * Used on the Dashboard and Getting Started pages.
 *
 * Props:
 *  onContactSupport - callback invoked when the Contact Support button is clicked
 *  className        - optional extra class applied to the root element
 */
function HelpOptionsFooter({ onContactSupport, className }) {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <h3>{t("gs.footer.title")}</h3>
      <div className="help-options-grid">
        <div className="help-option-card">
          <FontAwesomeIcon icon={faComments} className="help-option-icon" />
          <h4>{t("gs.footer.chatWithScout.title")}</h4>
          <p>
            {t("gs.footer.chatbotTip.prefix")}{" "}
            <strong>{t("gs.footer.chatbotTip.scoutName")}</strong>,{" "}
            {t("gs.footer.chatbotTip.middle")}{" "}
            <strong>{t("gs.footer.chatbotTip.dpgName")}</strong>{" "}
            {t("gs.footer.chatbotTip.suffix")}
          </p>
        </div>
        <div className="help-option-card">
          <FontAwesomeIcon
            icon={faQuestionCircle}
            className="help-option-icon"
          />
          <h4>{t("gs.footer.contactSupport.title")}</h4>
          <p>{t("gs.footer.contactSupport.description")}</p>
          <button
            className="help-option-btn"
            onClick={() => onContactSupport && onContactSupport()}
          >
            {t("gs.footer.contactSupport.button")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default HelpOptionsFooter;
